import * as Yup from 'yup';

export const validationSchema = Yup.object({
  status: Yup.string().required('Status is required'),
  summary: Yup.string()
    .required('Summary is required')
    .max(500, 'Summary must not exceed 500 characters'),
});
